import { motion } from "framer-motion";
import { headingVariants, fadeInVariants, viewportSettings } from "../../../shared/utils/animations";
import styles from "./buy-extension.module.scss";

const BuyExtensions = (props: { url: string }) => {
  const BOOKING_URL = `https://www.vagaro.com/lawameraki/services`;

  return (
    <div className={`${styles["container"]}`}>
      <div
        className={`${styles["model-left-container"]} ${styles["meraki-luxury-saloon"]}`}
      >
        <motion.div
          initial="headingOffScreen"
          whileInView="headingOnScreen"
          viewport={viewportSettings}
          variants={headingVariants}
        >
          <h2>Abundance Hair Extensions</h2>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          {/* <p> Buy our luxury hair extensions </p> */}
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <button
            onClick={() => {
              window.open(BOOKING_URL, "_blank");
            }}
          >
            Book a Consultation
          </button>
        </motion.div>
      </div>
      <div className={`${styles["model-right-container"]} `}>
        {/* <h1>Abundance Hair Extensions</h1> */}
        <img
          draggable={false}
          src={props.url}
          alt="luxury salon"
          className={`${styles["model-image"]}`}
        />
      </div>
    </div>
  );
};

export default BuyExtensions;
